import { z } from 'zod';

export const missionHistoryLifecyclesSchema = z.object({
  lifecycle: z.string(),
  updated_at: z.string(),
  updated_by: z.string(),
});

export const missionHistorySchema = z.object({
  id: z.number(),
  lifecycles: z.array(missionHistoryLifecyclesSchema),
});

export const missionSchema = z.object({
  id: z.number(),
  vehicle: z.number(),
  vehicle_display_identifier: z.string(),
  provider_identifier: z.string(),
  created_by: z.string(),
  lifecycle: z.string(),
  progress: z.string(),
  provider_departure_node: z.string().nullable(),
  provider_destination_node: z.string(),
  estimated_distance: z.number(),
  estimated_duration: z.string(),
  remaining_distance: z.number(),
  remaining_duration: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  dispatch_destination_node_name: z.string().nullable(),
  shift_id: z.number().nullable(),
});

export const missionPatchSchema = z.object({
  lifecycle: z.string(),
});

export type MissionHistory = z.infer<typeof missionHistorySchema>;
export type MissionHistoryLifecycles = z.infer<typeof missionHistoryLifecyclesSchema>;
export type IMission = z.infer<typeof missionSchema>;
export type IMissionPatch = z.infer<typeof missionPatchSchema>;
